<div class="app__internal--links app__role--players--card mb-0">
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        hideToggle
        [disabled]="true"
        [expanded]="true"
        class="parametersPanel relative shadow-none rounded-t-none rounded-b-none mt-[-10px]"
      >
        <mat-expansion-panel-header class="h-10 disable_ripple">
          <mat-panel-title>
            <div class="app__between--justified--content flex-row w-full">
              <p class="m-0 font-bold text-[#010B18] text-base flex items-center">Linked Templates</p>

              <p
                [matTooltip]="filterType"
                style="
                  padding: 0px 6px 0px 12px;
                  width: 134px;
                  height: 36px;
                  line-height: 36px;
                  text-align: center;
                  justify-content: space-between;
                  margin: 0 6px;
                  display: flex;
                "
                class="app__form--attribute--title rounded border-[1px] font-medium text-[12px]"
                [ngClass]="{
                  'text-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing,
                  'text-[#C1C2C5] border-[1.2px] border-[#B1ACB066] hover:cursor-default': isRemoveEditSaveSharing
                }"
                [matMenuTriggerFor]="isRemoveEditSaveSharing ? null : menuItem"
              >
                {{ filterType | truncateStrPipe : 16 }}
                <span class="material-icons relative f18 top-[9px]" [ngClass]="{ 'text-[#25508e] hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5]': isRemoveEditSaveSharing }"> arrow_drop_down </span>
              </p>
              <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel w-[230px]">
                <div style="max-height: 200px; overflow: auto">
                  @for (type of filterTypeList; track type) {
                  <button
                    mat-menu-item
                    class="popup-menu-item text-[#18191c]"
                    [ngClass]="{ 'bg-[#EBF0FA] text-[#25508E] font-semibold': filterType === type }"
                    style="width: 220px; font-size: 14px; font-weight: 400; padding: 10px 12px"
                    (click)="filterType = type"
                  >
                    {{ type }}
                  </button>
                  }
                </div>
              </mat-menu>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-[10px]" style="margin: 0 -24px">
          @if(isLoading || ai_is_loading){ @if(ai_is_loading){
          <div style="margin-top: 32px; width: 100%">
            <div style="margin: auto; width: 90px">
              <ng-lottie [options]="animation"></ng-lottie>
            </div>
            <p class="text-[#53565B] text-base m-0" style="line-height: 36px !important; text-align: center">
              One moment while <span class="text-[#25508E] font-semibold"> Kinnect AI </span> processes this document...
            </p>
          </div>

          }@else{
          <div class="ph-item width-100per loader-body-item" style="padding: 0px; border: 0px; margin-bottom: 0px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row" style="margin: 12px">
                <div class="ph-col-4"></div>
                <div class="ph-col-6 empty"></div>
                <div class="ph-col-2"></div>
              </div>
            </div>
          </div>

          } }@else{

          <mat-form-field
            style="width: 100%; border: 1px solid #53565b26; height: 56px; margin-bottom: 12px; border-radius: 8px"
            class="temp-alignment"
            id="access-manager-matAutoComplete"
            matTooltipClass="add-member-tooltip"
            [ngClass]="{
          'white-background': isInputFocused,
          'temp-alignment': !isInputFocused,
          'bg-[#F5F5F5] border-[#C1C2C5]': isRemoveEditSaveSharing
        }"
          >
            <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
              <img src="assets/images/search-blue.svg" width="20px" height="20px" />
            </div>

            <input
              type="text"
              matInput
              #myInput
              aria-label="Number"
              [formControl]="connectionUserFormControl"
              [matAutocomplete]="auto"
              [placeholder]="textBoxPlaceHolder"
              [disabled]="isRemoveEditSaveSharing"
              class="addMember global-input text-base font-sans font-normal text-[#53565B]"
              [ngClass]="{ 'text-[#53565B66]': isRemoveEditSaveSharing }"
              (focus)="onInputFocus()"
              (blur)="onInputBlur()"
            />

            @if (connectionUserFormControl.value) {
            <div matSuffix (click)="clearInput()">
              <mat-icon class="close-input-icon text-[#898F9E]">close</mat-icon>
            </div>
            }

            <mat-autocomplete #auto="matAutocomplete" class="search-scroll-main global-search-scroll-main">
              <div style="height: calc(100vh - 356px); max-height: 320px; overflow-y: auto; padding: 8px 0px 16px 0px">
                @for (template of existingTemplates | filterWorkspace : connectionUserFormControl.value; track template.id) {
                @if(template?.section_name == filterType || filterType == 'All Types'){
                <div
                  class="flex justify-between px-4 py-3 bg-white mb-2 cursor-pointer hover:bg-[#EBF0FA]"
                  (click)="linkTemplateExistingForm(template)"
                >
                  <div class="flex gap-2">
                    <img
                      [src]="template.profile_image_url"
                      [ngClass]="{ 'ai-border-grid': template.ai_suggestion }"
                      class="bg-[#EBEDFA] p-2 w-9 h-9 rounded"
                    />
                    <div>
                      <p [matTooltip]="template.form_name" class="text-[#18191c] font-semibold text-xs m-0">
                        {{ template.form_name | truncateStrPipe : 26 }}
                      </p>
                      <p [matTooltip]="template.type" class="text-[#707070] text-xs font-normal m-0">
                        @if (template.ai_suggestion) {
                        <img style="height: 16px" src="assets/images/ai_suggestion_small.svg" />
                        }
                        {{ template.type | truncateStrPipe : 36 }}
                      </p>
                    </div>
                  </div>
                  <div style="display: flex">
                    <span
                      class="app__discovery--option--top--aligned--tag text-[#5475C0] mr-2"
                      [matTooltip]="template?.vault_name"
                      style="width: 140px !important; position: relative; min-width: 140px; top: 4px; max-width: 140px"
                    >
                      <img [src]="'assets/images/' + template.vault_type + '-small.svg'" width="14px" height="14px" />
                      <span class="paragraph__medium text-[12px] sm:text-[12px] leading-[20px] ml-[2px]">
                        {{ template?.vault_name | capitalizeFirstWord | truncateStrPipe : 15 }}</span
                      >
                    </span>
                  </div>
                </div>
                } }
              </div>
              <mat-option disabled style="display: none"></mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="flex flex-col overflow-auto max-h-[286px]">
            @for (template of linkedForms; track template; let i = $index) {
            <div
              style="width: 100%"
              (click)="template?.writeAccess ? openManageTemplate(template) : null"
              [matTooltip]="template?.writeAccess ? '' : 'You don’t have access to ' + template.form_name"
              class="mb-1.5 pr-3 py-3 border-[#d3dce8] bg-transparent border-solid border rounded-lg flex justify-between"
              [ngClass]="{ 'pl-1': !isRemoveEditSaveSharing, 'pl-3': isRemoveEditSaveSharing, 'hover:cursor-pointer': template?.writeAccess }"
            >
              <div class="flex w-full">
                <mat-checkbox
                  *ngIf="!isRemoveEditSaveSharing"
                  class="app__common--multiple--selection--checkbox"
                  [(ngModel)]="selectionState['linked_template_' + i]"
                  (change)="onDocumentLinkedTemplateSelectionChange('linked_template', template, i, $event.checked)"
                  (click)="$event.stopPropagation()"
                >
                </mat-checkbox>
                <img class="bg-[#f4f4f4] rounded p-1.5 h-10 mr-1.5" style="margin-top: 5px" [src]="template?.profile_image_url" />
                <div class="w-full">
                  <div class="flex justify-between w-full">
                    <div class="flex flex-col" style="justify-content: center; margin-top: 6px">
                      <p class="app__form--attribute--title text-sm leading-[20px] m-0">
                        {{ template.form_name | truncateStrPipe : 25 }}
                      </p>
                      <p style="text-transform: capitalize" class="app__form--attribute--title m-0 text-xs text-[#707070] font-normal">
                        {{ template?.type_template }}
                      </p>
                    </div>
                    <div class="flex">
                      <img src="assets/images/exsting-form-suggestion.svg" style="margin-top: 12px !important" class="h-6" />
                      <button
                        style="
                          font-weight: 600;
                          font-size: 12px !important;
                          height: 32px;
                          width: 55px !important;
                          margin-left: 8px;
                          margin-top: 8px;
                          padding: 0 9px !important;
                        "
                        class="bg-[#F5f5f5] text-[#828282] text-xs px-4 py-2 rounded-md"
                      >
                        Linked
                      </button>

                      <div (click)="$event.stopPropagation()">
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="isRemoveEditSaveSharing ? null : menuItem"
                          [disableRipple]="true"
                          [disabled]="isRemoveEditSaveSharing"
                          [ngClass]="{ 'h-full text-[#25508E]': !isRemoveEditSaveSharing, 'h-full text-[#C1C2C5]': isRemoveEditSaveSharing }"
                        >
                          <div class="see-more-btn"><span class="material-icons horiz">more_vert</span></div>
                        </button>

                        <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                          <button mat-menu-item class="popup-menu-item" (click)="deleteFileFunction(template)">
                            <p class="menuitem-text" style="color: red !important">
                              <img width="18px" src="assets/images/Link_Horizontal_Off.svg" />Disconnect
                            </p>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            } @for (suggestions of suggestions_data_already_in_system; track suggestions; let i = $index) { @if(suggestions.form_name){
            <div
              (click)="suggestions?.suggested_vault_user_form_id && suggestions?.writeAccess ? openSuggestionTemplate(suggestions) : null"
              class="w-full mb-1.5 pr-3 py-3 border-[#d3dce8] bg-transparent border-solid border rounded-lg flex justify-between"
              [ngClass]="{ 'pl-1': !isRemoveEditSaveSharing, 'pl-3': isRemoveEditSaveSharing }"
            >
              <div class="flex w-full items-center">
                <div class="flex items-center w-full">
                  <mat-checkbox
                    *ngIf="!isRemoveEditSaveSharing"
                    class="app__common--multiple--selection--checkbox"
                    [(ngModel)]="selectionState['suggestion_existing_' + i]"
                    (change)="onDocumentLinkedTemplateSelectionChange('existing_ai_suggestion', suggestions, i, $event.checked)"
                    (click)="$event.stopPropagation()"
                  >
                  </mat-checkbox>
                  @if(suggestions?.suggested_vault_user_form_id){
                  <img
                    class="bg-[#f4f4f4] rounded p-1.5 h-8 mr-1.5 ai-border-grid"
                    [src]="suggestions?.suggested_from_profile_image_url || suggestions?.suggested_from_image"
                  />

                  }@else{
                  <img class="bg-[#f4f4f4] rounded p-1.5 h-8 mr-1.5 ai-border-grid" [src]="suggestions?.suggested_template_image" />

                  }
                  <div class="w-full">
                    <div class="flex justify-between w-full items-center">
                      <div class="flex flex-col" style="justify-content: center">
                        <p class="app__form--attribute--title text-sm leading-[20px] m-0 flex flex-col">
                          {{ suggestions?.form_name || suggestions?.type | truncateStrPipe : 25 }}

                          <span class="m-0 text-[#707070] font-normal capitalize text-xs">
                            <img style="height: 16px" src="assets/images/ai_suggestion_small.svg" />
                            {{ suggestions?.type_template || suggestions?.suggested_type }}
                          </span>
                        </p>
                      </div>
                      <div class="flex h-full items-center">
                        @if(suggestions?.suggested_vault_form_id){
                        <span class="bg-[#D1F6E1] leading-6 mx-2 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded text-center"> New </span>
                        }@else{
                        <img src="assets/images/exsting-form-suggestion.svg" style="margin-top: 4px !important" class="mx-2 h-6" />
                        }
                        <button
                          (click)="linkTemplate(suggestions); $event.stopPropagation()"
                          style="font-weight: 600; font-size: 12px !important; width: 55px !important; height: 32px; position: relative; top: 1px"
                          class="text-white text-xs px-4 py-2 rounded-md"
                          [ngClass]="{ 'bg-[#25508E]': !isRemoveEditSaveSharing, 'bg-k-grey hover:cursor-default': isRemoveEditSaveSharing }"
                          [disabled]="isRemoveEditSaveSharing"
                        >
                          {{ suggestions?.form_name ? 'Link' : 'Add' }}
                        </button>
                        <button
                          style="width: 48px !important; height: 32px !important"
                          class="w-fit h-full p-0"
                          [ngClass]="{
                            'text-[#25508E]': !isRemoveEditSaveSharing,
                            'text-[#C1C2C5]': isRemoveEditSaveSharing
                          }"
                          (click)="$event.stopPropagation()"
                          mat-icon-button
                          [matMenuTriggerFor]="isRemoveEditSaveSharing ? null : suggestionMenu"
                          [disableRipple]="true"
                          [disabled]="isRemoveEditSaveSharing"
                        >
                          <span class="material-icons horiz">more_vert</span>
                        </button>
                        <mat-menu #suggestionMenu="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                          <button mat-menu-item (click)="removeDocumentLinkedTemplateSuggestion(suggestions)">
                            <span class="app__form--attribute--title items-center text-center font-normal text-sm text-[#EB5757]">
                              <img style="position: relative; top: -2px" src="assets/images/inbox/trash.svg" />
                              Delete suggestion
                            </span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            } }
          </div>
          @if(linkedForms.length == 0 && suggestions_data_already_in_system.length == 0){
          <div class="cursor-pointer">
            <div class="app__centered-item flex-row text-center h-16 border rounded-lg border-[#d3dce8] border-solid">
              <img src="assets/images/no-file-icon.svg" class="w-6 h-6" />
              <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
                No <span class="font-bold text-[#25508E]"> Templates</span> to show
              </span>
            </div>
          </div>
          }}
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
</div>
<div class="app__internal--links app__role--players--card mb-0" style="margin-top: 32px">
  <mat-dialog-content class="mat-dialog-content">
    <mat-accordion class="prevent-click" [@.disabled]="true">
      <mat-expansion-panel
        hideToggle
        [disabled]="true"
        [expanded]="true"
        class="parametersPanel relative shadow-none rounded-t-none rounded-b-none mt-[-10px]"
      >
        <mat-expansion-panel-header class="h-10 disable_ripple">
          <mat-panel-title>
            <div class="app__between--justified--content flex-row w-full">
              <p class="m-0 font-bold text-[#010B18] text-base flex items-center">New Template Suggestions</p>
              <p
                [matTooltip]="filterTypeNew"
                style="
                  padding: 0px 6px 0px 12px;
                  width: 134px;
                  height: 36px;
                  line-height: 36px;
                  text-align: center;
                  justify-content: space-between;
                  margin: 0 6px;
                  display: flex;
                "
                class="app__form--attribute--title rounded border-[1px] font-medium text-[12px] hover:cursor-pointer"
                [ngClass]="{
                  'text-[#25508E] hover:cursor-pointer': !isRemoveEditSaveSharing,
                  'text-[#C1C2C5] border-[1.2px] border-[#B1ACB066] hover:cursor-default': isRemoveEditSaveSharing
                }"
                [matMenuTriggerFor]="isRemoveEditSaveSharing ? null : menuItemNew"
              >
                {{ filterTypeNew | truncateStrPipe : 16 }}
                <span class="material-icons relative f18 top-[9px]" [ngClass]="{ 'text-[#25508e]': !isRemoveEditSaveSharing, 'text-[#C1C2C5]': isRemoveEditSaveSharing }"> arrow_drop_down </span>
              </p>
              <mat-menu #menuItemNew="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel w-[230px]">
                <div style="max-height: 200px; overflow: auto">
                  @for (type of filterTypeList; track type) {
                  <button
                    mat-menu-item
                    class="popup-menu-item text-[#18191c]"
                    [ngClass]="{ 'bg-[#EBF0FA] text-[#25508E] font-semibold': filterTypeNew === type }"
                    style="width: 220px; font-size: 14px; font-weight: 400; padding: 10px 12px"
                    (click)="filterTypeNew = type"
                  >
                    {{ type }}
                  </button>
                  }
                </div>
              </mat-menu>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-[10px]" style="margin: 0 -24px">
          @if(isLoading || ai_is_loading){ @if(ai_is_loading){
          <div style="margin-top: 32px; width: 100%">
            <div style="margin: auto; width: 90px">
              <ng-lottie [options]="animation"></ng-lottie>
            </div>
            <p class="text-[#53565B] text-base m-0" style="line-height: 36px !important; text-align: center">
              One moment while <span class="text-[#25508E] font-semibold"> Kinnect AI </span> processes this document...
            </p>
          </div>

          }@else{
          <div class="ph-item width-100per loader-body-item" style="padding: 0px; border: 0px; margin-bottom: 0px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row" style="margin: 12px">
                <div class="ph-col-4"></div>
                <div class="ph-col-6 empty"></div>
                <div class="ph-col-2"></div>
              </div>
            </div>
          </div>

          } }@else{

          <mat-form-field
            style="width: 100%; border: 1px solid #53565b26; height: 56px; margin-bottom: 12px; border-radius: 8px"
            class="temp-alignment"
            id="access-manager-matAutoComplete"
            matTooltipClass="add-member-tooltip"
            [ngClass]="{
          'white-background': isInputFocused,
          'temp-alignment': !isInputFocused,
          'bg-[#F5F5F5] border-[#C1C2C5]': isRemoveEditSaveSharing
        }"
          >
            <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
              <img src="assets/images/search-blue.svg" width="20px" height="20px" />
            </div>
            <input
              type="text"
              matInput
              #myInput
              aria-label="Number"
              [formControl]="connectionNewUserFormControl"
              [matAutocomplete]="autoNew"
              [placeholder]="textBoxPlaceHolderCreate"
              [disabled]="isRemoveEditSaveSharing"
              class="addMember global-input text-base font-sans font-normal text-[#53565B]"
              [ngClass]="{ 'text-[#53565B66]': isRemoveEditSaveSharing }"
              (focus)="onInputFocusNew()"
              (blur)="onInputBlurNew()"
            />

            @if (connectionNewUserFormControl.value) {
            <div matSuffix (click)="clearInputNew()">
              <mat-icon class="close-input-icon text-[#898F9E]">close</mat-icon>
            </div>
            }

            <mat-autocomplete #autoNew="matAutocomplete" class="search-scroll-main global-search-scroll-main">
              <div style="height: calc(100vh - 356px); max-height: 320px; overflow-y: auto; padding: 8px 0px 16px 0px" class="">
                @for (form of formsList | filterFormList : connectionNewUserFormControl.value; track form.id) { @if(filterTypeNew == 'All Types' ||
                form?.organization_section == filterTypeNew ){ @if(form.type != 'Document'){
                <div class="flex justify-between px-4 py-3 mb-2 bg-white cursor-pointer hover:bg-[#EBF0FA]" (click)="createFileNew(form)">
                  <div class="flex gap-2">
                    <img
                      [src]="form.image"
                      style="height: 16px"
                      [ngClass]="{ 'ai-border-grid': form.ai_suggestion }"
                      class="bg-[#EBEDFA] p-2 w-9 h-9 rounded"
                    />
                    <div>
                      <p class="text-[#18191c] font-semibold text-xs m-0" [matTooltip]="form.type">
                        {{ form.type | truncateStrPipe : 48 }}
                      </p>
                      <p class="text-[#707070] text-xs font-normal m-0" [matTooltip]="form.organization_section">
                        @if (form.ai_suggestion) {
                        <img style="height: 16px" src="assets/images/ai_suggestion_small.svg" />
                        }
                        {{ form.organization_section | truncateStrPipe : 35 }}
                      </p>
                    </div>
                  </div>
                </div>
                } } }
              </div>
              <mat-option disabled style="display: none"></mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="flex flex-col overflow-auto max-h-[286px]">
            @for (suggestions of suggestions_data; track suggestions; let i = $index) { @if(!suggestions?.form_name){
            <div
              (click)="suggestions?.suggested_vault_user_form_id && suggestions?.writeAccess ? openSuggestionTemplate(suggestions) : null"
              class="w-full mb-1.5 pr-3 py-3 border-[#d3dce8] bg-transparent border-solid border rounded-lg flex justify-between"
              [ngClass]="{ 'pl-2 hover:cursor-pointer': !isRemoveEditSaveSharing, 'pl-4 hover:cursor-default': isRemoveEditSaveSharing }"
            >
              <div class="flex w-full items-center">
                <div class="flex items-center w-full">
                  <mat-checkbox
                    *ngIf="!isRemoveEditSaveSharing"
                    class="app__common--multiple--selection--checkbox"
                    [(ngModel)]="selectionState['suggestion_new_' + i]"
                    (change)="onDocumentLinkedTemplateSelectionChange('new_ai_suggestion', suggestions, i, $event.checked)"
                    (click)="$event.stopPropagation()"
                  >
                  </mat-checkbox>
                  @if(suggestions?.suggested_vault_user_form_id){
                  <img
                    class="bg-[#f4f4f4] rounded p-1.5 h-8 mr-1.5 ai-border-grid"
                    [src]="suggestions?.suggested_from_profile_image_url || suggestions?.suggested_from_image"
                  />

                  }@else{
                  <img class="bg-[#f4f4f4] rounded p-1.5 h-8 mr-1.5 ai-border-grid" [src]="suggestions?.suggested_template_image" />

                  }
                  <div class="w-full">
                    <div class="flex justify-between w-full items-center">
                      <div class="flex flex-col" style="justify-content: center">
                        <p class="app__form--attribute--title text-sm leading-[20px] m-0 flex flex-col">
                          {{ suggestions?.form_name || suggestions?.type | truncateStrPipe : 25 }}

                          <span class="m-0 text-[#707070] font-normal capitalize text-xs">
                            <img style="height: 16px" src="assets/images/ai_suggestion_small.svg" />
                            {{ suggestions?.type_template || suggestions?.suggested_type }}
                          </span>
                        </p>
                      </div>
                      <div class="flex h-full items-center gap-2">
                        @if(suggestions?.suggested_vault_form_id){
                        <span class="bg-[#D1F6E1] leading-6 mx-2 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded text-center"> New </span>
                        }@else{
                        <img src="assets/images/exsting-form-suggestion.svg" style="margin-top: 6.5px !important" class="mx-2 h-6" />
                        }
                        <button
                          (click)="linkTemplate(suggestions); $event.stopPropagation()"
                          style="font-weight: 600; font-size: 12px !important; position: relative; height: 32px"
                          class="text-white text-xs px-4 py-2 rounded-md"
                          [ngClass]="{ 'bg-[#25508E] hover:bg-[#123260]': !isRemoveEditSaveSharing, 'bg-k-grey hover:cursor-default': isRemoveEditSaveSharing }"
                          [disabled]="isRemoveEditSaveSharing"
                        >
                          {{ suggestions?.form_name ? 'Link' : 'Add' }}
                        </button>
                        <button
                          class="w-fit h-full p-0"
                          [ngClass]="{
                            'text-[#25508E]': !isRemoveEditSaveSharing,
                            'text-[#C1C2C5]': isRemoveEditSaveSharing
                          }"
                          (click)="$event.stopPropagation()"
                          mat-icon-button
                          [matMenuTriggerFor]="isRemoveEditSaveSharing ? null : suggestionMenu"
                          [disableRipple]="true"
                          [disabled]="isRemoveEditSaveSharing"
                        >
                          <span class="material-icons horiz">more_vert</span>
                        </button>
                        <mat-menu #suggestionMenu="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel">
                          <button mat-menu-item (click)="removeDocumentLinkedTemplateSuggestion(suggestions)">
                            <span class="app__form--attribute--title items-center text-center font-normal text-sm text-[#EB5757]">
                              <img style="position: relative; top: -2px" src="assets/images/inbox/trash.svg" />
                              Delete suggestion
                            </span>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            } }
          </div>
          @if( suggestions_data.length == 0){
          <div class="cursor-pointer">
            <div class="app__centered-item flex-row text-center h-16 border rounded-lg border-[#d3dce8] border-solid">
              <img src="assets/images/no-file-icon.svg" class="w-6 h-6" />
              <span class="app__form--attribute--title font-semibold text-[12px] ml-2">
                No <span class="font-bold text-[#25508E]"> Templates</span> to show
              </span>
            </div>
          </div>

          } }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>
</div>
